import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/nomeacuerdo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  alt: "nomeacuerdo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "hello" }, "Hello there!", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("My name is "),
  /*#__PURE__*/_createVNode("strong", null, "Nicolás Arteaga Nieto")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("I'm a "),
  /*#__PURE__*/_createVNode("strong", null, "Frontend Developer"),
  /*#__PURE__*/_createTextVNode(" based on "),
  /*#__PURE__*/_createVNode("strong", null, "Bogotá, Colombia"),
  /*#__PURE__*/_createTextVNode(".")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Curriculum = _resolveComponent("Curriculum")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_Curriculum)
  ]))
}